export default "__VITE_ASSET__0BNNoRJY__"